module.exports = __webpack_public_path__ + "static/img/join-code.588a85f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/join-code.png
// module id = 2BVO
// module chunks = 0